/// <reference types="vite/client" />

/** Registra o service worker (shell estatico + pagina offline; nunca dados
 *  de paciente — ver public/sw.js). So em build de producao; falha silenciosa:
 *  o app funciona igual sem ele, so nao fica instalavel. */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
  });
}
